"use client"

import { useAtomValue } from "jotai"
import React from "react"
import { useTranslation } from "react-i18next"

import BreakFromCentered from "@/shared-module/common/components/Centering/BreakFromCentered"
import withErrorBoundary from "@/shared-module/common/utils/withErrorBoundary"
import { LoadingRegion } from "@/shared-module/components"
import { courseMaterialAtom } from "@/state/course-material"

import ChapterGrid from "./ChapterGrid"

const CourseChapterGridBlock: React.FC = () => {
  const { t } = useTranslation("errors")
  const courseMaterialState = useAtomValue(courseMaterialAtom)

  if (courseMaterialState.status !== "ready") {
    return <LoadingRegion />
  }

  if (
    courseMaterialState.page?.course_id === null ||
    courseMaterialState.page?.course_id === undefined
  ) {
    return <div>{t("error-page-without-course")}</div>
  }

  return (
    <BreakFromCentered sidebar={false}>
      <div>
        <ChapterGrid courseId={courseMaterialState.page.course_id} />
      </div>
    </BreakFromCentered>
  )
}

export default withErrorBoundary(CourseChapterGridBlock)
